import { Form, Grid, Radio, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { estimatedMonthlyTransactionVolumes } from '../../constants';
import { estimatedMonthlyTransactionVolumeTextMap } from './StepForm.constants';
import { useFormData } from './StepForm.hooks';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    const { estimatedMonthlyTransactionValueData } = useFormData();

    return (
        <Form.Part>
            <Grid gap={12}>
                <Text font='body' fontSize='medium' fontWeight='regular'>
                    {messages.howOftenDoYouExpectTransactions}
                </Text>

                <Radio.Group
                    name='accountUsage.estimatedMonthlyTransactionVolume'
                    qa='estimatedMonthlyTransactionVolume'
                    direction='column'
                    spacing='12'
                >
                    {estimatedMonthlyTransactionVolumes.map((volume) => (
                        <Radio key={volume} value={volume}>
                            {estimatedMonthlyTransactionVolumeTextMap[volume]}
                        </Radio>
                    ))}
                </Radio.Group>
            </Grid>

            <Grid gap={12}>
                <Text font='body' fontSize='medium' fontWeight='regular'>
                    {messages.totalMonthlySpend}
                </Text>

                <Radio.Group
                    name='accountUsage.estimatedMonthlyTransactionValue'
                    qa='estimatedMonthlyTransactionValue'
                    direction='column'
                    spacing='12'
                >
                    {estimatedMonthlyTransactionValueData.map(({ text, value }) => (
                        <Radio key={value} value={value}>
                            {text}
                        </Radio>
                    ))}
                </Radio.Group>
            </Grid>
        </Form.Part>
    );
});

StepForm.displayName = 'StepForm';
